import horizontalBarMiniChartTemplate from './horizontalBarMiniChart.html';
import './horizontalBarMiniChart.scss';

export default angular
  .module('main.dashboardPanel.horizontalBarMiniChart', [])

  .directive('horizontalBarMiniChart', () => {
    return {
      restrict: 'E',
      template: horizontalBarMiniChartTemplate,
      scope: {
        series: '=', // data series array {data: number, label: string}[]
      },
      controller: ($scope, $filter, $element) => {
        const $t = $filter('translate');

        init();

        function init() {
          $scope.$watch('series', () => {
            if ($scope.series) {
              $scope.maxWidth = Math.max(...$scope.series.map(s => s.data));
            } else {
              $scope.maxWidth = 0;
            }
          }, true);

        }
      }
    };
  })
  .name;
